import React, { useState, useEffect } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { SiteExcel } from './SiteExcel';
import TenableExcel from '../components/TenableHooK/CreateTenableExcel'
import { SiteTitle } from "./SiteTitle";
import { loginInfo } from "./globalFunction/global_string";


function HCLAppScanBackground() {
    const [value, setValue] = useState('1');
    const [tenablePage, setTenablePage] = useState(localStorage.getItem('tenable_page') === 'true');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        const handleTenablePageChanged = () => {
            const tenablePageValue = localStorage.getItem('tenable_page') === 'true';
            setTenablePage(tenablePageValue);
        };

        // 添加事件监听器，当 tenable_page 变化时更新状态
        window.addEventListener('tenablePageChanged', handleTenablePageChanged);

        // 在组件卸载时移除事件监听器
        return () => {
            window.removeEventListener('tenablePageChanged', handleTenablePageChanged);
        };
    }, []);
    return (
        <div>
            <SiteTitle />

            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="tracking tabs"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "blue",
                            }
                        }}
                    >
                        <Tab label="檢測網站匯入" value="1" />
                        {tenablePage && <Tab label="檢測主機匯入" value="2" />}
                    </Tabs>
                </Box>
                <TabPanel value="1">
                    <SiteExcel />
                </TabPanel>
                {tenablePage && (
                    <TabPanel value="2">
                        <TenableExcel />
                    </TabPanel>
                )}

            </TabContext>
        </div>
    );
}

export default HCLAppScanBackground;
